/**
 * combined-campaign-performance API satırlarını kanal tipine göre gruplayıp tablo + TOTAL satırı üretir.
 */
export function aggregateCombinedCampaignPerformanceRows(result) {
  if (!result || !Array.isArray(result) || result.length === 0) {
    return [];
  }

  const groupedData = {};
  const campaignsByType = {};

  result.forEach((item) => {
    const campaignType = item.campaignType;

    if (!campaignType || campaignType === '(not set)') {
      return;
    }

    if (!campaignsByType[campaignType]) {
      campaignsByType[campaignType] = new Set();
    }
    if (item.campaignName) {
      campaignsByType[campaignType].add(item.campaignName);
    }

    if (!groupedData[campaignType]) {
      groupedData[campaignType] = {
        source: campaignType,
        count: 0,
        sessions: 0,
        ga4_transaction: 0,
        ga4_revenue: 0,
        google_ads_clicks: 0,
        google_ads_cost: 0,
        google_ads_transaction: 0,
        google_ads_revenue: 0,
        google_ads_impression: 0,
        dates: new Set(),
        campaignCount: 0,
      };
    }

    if (item.date) {
      groupedData[campaignType].dates.add(item.date);
    }

    groupedData[campaignType].count += 1;
    groupedData[campaignType].sessions += Number(item.sessions || 0);
    groupedData[campaignType].ga4_transaction += Number(item.ga4Transaction || 0);
    groupedData[campaignType].ga4_revenue += Number(item.ga4Revenue || 0);
    groupedData[campaignType].google_ads_clicks += Number(item.googleAdsClicks || 0);
    groupedData[campaignType].google_ads_cost += Number(item.googleAdsCost || 0);
    groupedData[campaignType].google_ads_transaction += Number(item.googleAdsTransaction || 0);
    groupedData[campaignType].google_ads_revenue += Number(item.googleAdsRevenue || 0);
    groupedData[campaignType].google_ads_impression += Number(item.googleAdsImpression || 0);
  });

  const finalData = Object.keys(groupedData).map((type) => {
    const item = groupedData[type];

    item.cpc = item.google_ads_clicks > 0 ? item.google_ads_cost / item.google_ads_clicks : 0;
    item.cps = item.sessions > 0 ? item.google_ads_cost / item.sessions : 0;
    item.date_count = item.dates.size;
    item.dates = Array.from(item.dates);
    item.campaignCount = campaignsByType[type] ? campaignsByType[type].size : 0;
    return item;
  });

  finalData.sort((a, b) => b.google_ads_cost - a.google_ads_cost);

  if (finalData.length === 0) {
    return [];
  }

  const totalCampaignCount = Object.values(campaignsByType).reduce(
    (total, campaigns) => total + campaigns.size,
    0
  );

  const total = finalData.reduce(
    (acc, item) => {
      acc.count += item.count;
      acc.sessions += item.sessions;
      acc.ga4_transaction += item.ga4_transaction;
      acc.ga4_revenue += item.ga4_revenue;
      acc.google_ads_clicks += item.google_ads_clicks;
      acc.google_ads_cost += item.google_ads_cost;
      acc.google_ads_transaction += item.google_ads_transaction;
      acc.google_ads_revenue += item.google_ads_revenue;
      acc.google_ads_impression += item.google_ads_impression;
      return acc;
    },
    {
      source: 'TOTAL',
      count: 0,
      sessions: 0,
      ga4_transaction: 0,
      ga4_revenue: 0,
      google_ads_clicks: 0,
      google_ads_cost: 0,
      google_ads_transaction: 0,
      google_ads_revenue: 0,
      google_ads_impression: 0,
      date_count: Math.max(...finalData.map((item) => item.date_count || 0)),
      campaignCount: totalCampaignCount,
    }
  );

  total.cpc = total.google_ads_clicks > 0 ? total.google_ads_cost / total.google_ads_clicks : 0;
  total.cps = total.sessions > 0 ? total.google_ads_cost / total.sessions : 0;

  finalData.push(total);

  return finalData;
}
